import { render, staticRenderFns } from "./MainLedgerIzvodPrijedlog.vue?vue&type=template&id=1e6ef88d&scoped=true"
import script from "./MainLedgerIzvodPrijedlog.vue?vue&type=script&lang=js"
export * from "./MainLedgerIzvodPrijedlog.vue?vue&type=script&lang=js"
import style0 from "./MainLedgerIzvodPrijedlog.vue?vue&type=style&index=0&id=1e6ef88d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6ef88d",
  null
  
)

export default component.exports